import React, { useEffect } from 'react';
import dayjs from 'dayjs';
import Router from './routes/Router';
import { useSelectedElement } from './hooks/UseSelectedElement';

const locales: any = {
  ja: () => import('dayjs/locale/ja'),
  en: () => import('dayjs/locale/en'),
};

function loadLocale(language: any) {
  locales[language]().then(() => dayjs.locale(language));
}

const App: React.FC = () => {
  const { setSelectedElementId } = useSelectedElement();
  const fragment = window.location.hash.substring(1);

  useEffect(() => {
    if (fragment) {
      setSelectedElementId(fragment);
    }

    loadLocale('en');
  }, []);
  return <Router />;
};

export default App;
